import { render, staticRenderFns } from "./CamerasCard.vue?vue&type=template&id=8d470f22"
import script from "./CamerasCard.vue?vue&type=script&lang=js"
export * from "./CamerasCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports